import styles from "./movies-news.module.css";
import React, {useEffect, useRef, useState} from "react";
import ServerRequest from "../../serverRequests/ServerRequest";
import texts from "../../assets/ContextProvider/textsLocalized.json";
import {animateButtonPress} from "../../assets/AdditionalFunctions/AnimateButtonPress";
import fallBackImg1 from "./img/image 1.png";
import fallBackImg2 from "./img/image 2.png";
import fallBackImg3 from "./img/image 3.png";
import fallBackImg4 from "./img/image 4.png";
import fallBackImg5 from "./img/image 5.png";
import fallBackImg6 from "./img/image 6.png";
import fallBackImg7 from "./img/image 7.png";
import fallBackImg8 from "./img/image 8.png";
import fallBackImg9 from "./img/image 9.png";
import fallBackImg10 from "./img/image 10.png";
import fallBackImg11 from "./img/image 11.png";
import fallBackImg12 from "./img/image 12.png";
import fallBackImg13 from "./img/image 13.png";
import fallBackImg14 from "./img/image 14.png";
import fallBackImg15 from "./img/image 15.png";
import fallBackImg16 from "./img/image 16.png";
import fallBackImg17 from "./img/image 17.png";
import fallBackImg18 from "./img/image 18.png";
import fallBackImg19 from "./img/image 19.png";
import fallBackImg20 from "./img/image 20.png";
import {scrollToTop} from "../../assets/AdditionalFunctions/ScrollToTop";
import {ReactComponent as BtnUp} from "./img/icon-arrow_up.svg";
import Loader from "../../components/Loader/Loader";


const backgroundSummaryList = [
  "linear-gradient(180deg, #FFBEE1 0%, #FFF 100%)",
  "linear-gradient(180deg, #B6DDFF 0%, #FFF 100%)",
  "linear-gradient(180deg, #FFE2B9 0%, #FFF 100%)",
  "linear-gradient(180deg, #ECCBFF 0%, #FFF 100%)",
  "linear-gradient(180deg, #E5FFCB 0%, #FFF 100%)",
  "linear-gradient(180deg, #FFBEE1 0%, #FFF 100%)",
  "linear-gradient(180deg, #B6DDFF 0%, #FFF 100%)",
  "linear-gradient(180deg, #FFE2B9 0%, #FFF 100%)",
  "linear-gradient(180deg, #ECCBFF 0%, #FFF 100%)",
  "linear-gradient(180deg, #E5FFCB 0%, #FFF 100%)",
  "linear-gradient(180deg, #FFBEE1 0%, #FFF 100%)",
  "linear-gradient(180deg, #B6DDFF 0%, #FFF 100%)",
  "linear-gradient(180deg, #FFE2B9 0%, #FFF 100%)",
  "linear-gradient(180deg, #ECCBFF 0%, #FFF 100%)",
  "linear-gradient(180deg, #E5FFCB 0%, #FFF 100%)",
  "linear-gradient(180deg, #FFBEE1 0%, #FFF 100%)",
  "linear-gradient(180deg, #B6DDFF 0%, #FFF 100%)",
  "linear-gradient(180deg, #FFE2B9 0%, #FFF 100%)",
  "linear-gradient(180deg, #ECCBFF 0%, #FFF 100%)",
  "linear-gradient(180deg, #E5FFCB 0%, #FFF 100%)",
];
const fallBackImages = [
  fallBackImg1, fallBackImg2, fallBackImg3, fallBackImg4,
  fallBackImg5, fallBackImg6, fallBackImg7, fallBackImg8,
  fallBackImg9, fallBackImg10, fallBackImg11, fallBackImg12,
  fallBackImg13, fallBackImg14, fallBackImg15, fallBackImg16,
  fallBackImg17, fallBackImg18, fallBackImg19, fallBackImg20
];


const MoviesNews = () => {
  const [movieNews, setMovieNews] = useState([]);
  const [expandedIndexes, setExpandedIndexes] = useState([]);
  const btnInfoRefs = useRef([]);
  const sixthCardRef = useRef(null);
  const [showBtnUp, setShowBtnUp] = useState(false);
  const lastScrollY = useRef(0);
  const isScrollingUp = useRef(false);
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    const fetchedNewsData = async () => {
      try {
        setIsLoading(true);
        const serverData = await ServerRequest.getAllMovieNews();
        const parsedServerData = await serverData.json();

        if (parsedServerData.code === 200) {
          setMovieNews(parsedServerData.news);
          setIsLoading(false);
        }
      } catch (error) {
        console.log(error);
      }

    };

    fetchedNewsData();

  }, []);


  const handleExpandSummary = async (index) => {
    const targetBtnRef = {current: btnInfoRefs.current[index]};
    await animateButtonPress(targetBtnRef, styles.pressed);

    setExpandedIndexes((prev) =>
      prev.includes(index) ? [] : [index]
    );
  };


  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      isScrollingUp.current = currentScrollY < lastScrollY.current;
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowBtnUp(true);
        } else if (isScrollingUp.current) {
          setShowBtnUp(false);
        }
      },
      {
        root: null,
        threshold: 0.5,
      }
    );

    if (sixthCardRef.current) {
      observer.observe(sixthCardRef.current);
    }

    return () => {
      if (sixthCardRef.current) {
        observer.unobserve(sixthCardRef.current);
      }
    };
  }, [movieNews]);


  useEffect(() => {
    scrollToTop();
  }, []);


  const scrollToTopArrow = () => {
    window.scrollTo(
      {
        top: 0,
        behavior: 'smooth'
      }
    );
    setShowBtnUp(false);
  }


  return (
    <section className={styles['movie-news-section']}>
      <Loader isLoading={isLoading}/>
      <p className={styles.title}>
        {texts['movie-news']['movie-news-title']}
      </p>
      <div className={styles['movie-news-cards']}>
        {showBtnUp && (
          <div className={styles["btn-up-container"]}>
            <BtnUp className={styles["btn-up"]}
                   onClick={scrollToTopArrow}/>
          </div>
        )}
        {movieNews.length > 0 && movieNews.map((singleNews, index) => {

          const isExpanded = expandedIndexes.includes(index);
          const isSixth = index === 5;

          return (
            <div ref={isSixth ? sixthCardRef : null}
                 className={styles['movie-news-card']}
                 key={index}>
              <div className={styles['general-container-top-card']}>
                <img className={styles['top-wave-part-card']}
                     src={require("./img/top-wave-part-ticket.svg").default}
                     alt="top wave part card"/>
                <div className={styles['top-part-card']}>
                  {singleNews.image ?
                    <img className={styles['event-movie-img']}
                         src={singleNews.image}
                         loading="lazy"
                         alt="image of movie event"/> :
                    <img className={styles['event-movie-img']}
                         loading="lazy"
                         src={fallBackImages[index]}
                         alt="image of movie event"/>
                  }
                  <p className={styles['card-title']}>
                    {singleNews.title}
                  </p>
                </div>
              </div>

              <div className={styles['medium-part-card']}>
                <img className={styles['medium-part-card-img']}
                     src={require("./img/medium-part-ticket.svg").default}
                     alt="medium image divider"/>
              </div>

              <div className={styles['general-container-bottom-card']}>
                <div className={styles['bottom-part-card']}
                     style={{"background": backgroundSummaryList[index]}}>
                  <span
                    className={`${styles["card-summary"]} 
                    ${isExpanded ? styles["expanded"] : ""}`}
                  >
                    {singleNews.summary}
                </span>

                  <div className={styles['bottom-part-card-footer']}>
                    <span className={styles['release-date-news']}>
                      {singleNews.publishedAt}
                    </span>
                    <button ref={el => btnInfoRefs.current[index] = el}
                            className={styles['expanded-summary-btn']}
                            onClick={() => handleExpandSummary(index)}>
                      {isExpanded ?
                        texts['movie-news']['movie-show-less']
                        : texts['movie-news']['movie-show-more']}
                    </button>
                  </div>
                </div>
                <img className={styles['bottom-wave-part-card']}
                     src={require("./img/bottom-wave-part-ticket.svg").default}
                     alt="bottom wave part card"/>
              </div>
            </div>
          )
        })}
      </div>
      <p className={styles.notification}>
        {texts['movie-news']['first-movie-news-notification']} <br/>
        {texts['movie-news']['second-movie-news-notification']}
      </p>
    </section>
  )
}

export default MoviesNews;